import { useEffect } from 'react';
import axiosConn from '../../axiosConn';
import { OFFER_VERSION } from './hitLabServiceTerms';

// Price, purchased value and primary CTA must each be visible for a continuous
// second in this mounted offer. They may be seen sequentially on small screens.
export function isOfferAnchorVisible(node) {
  if (!node || document.visibilityState !== 'visible') return false;
  const r = node.getBoundingClientRect();
  const height = Math.min(r.bottom, window.innerHeight) - Math.max(0, r.top);
  const width = Math.min(r.right, window.innerWidth) - Math.max(0, r.left);
  if (height <= 0 || width <= 0 || height * width < r.height * r.width * 0.5)
    return false;
  const x = Math.max(0, r.left) + width / 2,
    y = Math.max(0, r.top) + height / 2;
  const top = document.elementFromPoint(x, y);
  return !!top && (node === top || node.contains(top));
}
export default function useHitLabOfferExposure({ intakeId, authConfig, refs }) {
  const token = authConfig?.headers?.Authorization;
  useEffect(() => {
    if (!intakeId || !token) return undefined;
    const seen = new Set(),
      started = new Map();
    let inFlight = false,
      complete = false,
      failures = 0,
      active = true;
    const tick = async () => {
      if (complete || inFlight || failures >= 3) return;
      refs.forEach((ref, index) => {
        if (!isOfferAnchorVisible(ref.current)) {
          started.delete(index);
          return;
        }
        if (!started.has(index)) started.set(index, Date.now());
        if (Date.now() - started.get(index) >= 1000) seen.add(index);
      });
      if (seen.size !== refs.length || document.visibilityState !== 'visible')
        return;
      inFlight = true;
      try {
        await axiosConn.post(
          'hitlab/intake/offer-exposure',
          { intakeId, version: OFFER_VERSION },
          { headers: { Authorization: token } },
        );
        if (active) complete = true;
      } catch {
        failures += 1;
      } finally {
        inFlight = false;
      }
    };
    const timer = window.setInterval(tick, 300);
    return () => {
      active = false;
      window.clearInterval(timer);
    };
    // Refs are stable anchors; a new intake/session starts a new observation.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [intakeId, token]);
}
